// extracted by mini-css-extract-plugin
export default {"resItemImg":"index_resItemImg__Ndzq7","img":"index_img__zWMM8"};